import React from 'react';

export default function ClaimStamp({ status, claimer, onClaim, onUnclaim, compact }) {
    if (status === 'unclaimed') {
        return (
            <div className="claim-block">
                <div className={'stamp unclaimed' + (compact ? ' stamp-compact' : '')}>
                    <span>Unclaimed</span>
                </div>
                <button className="claim-btn" onClick={onClaim}>
                    {compact ? 'claim →' : "I'll buy this →"}
                </button>
            </div>
        );
    }
    if (status === 'yours') {
        return (
            <div className="claim-block">
                <div className={'stamp yours' + (compact ? ' stamp-compact' : '')}>
                    <span>Claimed</span>
                    {!compact && <span className="stamp-by">by you</span>}
                </div>
                <button className="claim-btn unclaim-btn" onClick={onUnclaim}>
                    release
                </button>
            </div>
        );
    }
    return (
        <div className={'stamp claimed' + (compact ? ' stamp-compact' : '')}>
            <span>Claimed</span>
            <span className="stamp-by">by {claimer}</span>
        </div>
    );
}

export function claimStatus(purchasedBy, caller) {
    if (!purchasedBy) return 'unclaimed';
    if (purchasedBy === caller) return 'yours';
    return 'others';
}
